module.exports = __webpack_public_path__ + "static/media/sketches_unmapped.6e2dcc5d.gif";